<div id="contacts-popup" class="common-company-popup popup-md">
    <form class="form" role="form" autocomplete="off" [formGroup]="contactForm">
        <div class="popoup-hearder">
            <h2 class="m-b-5" mat-dialog-title>Personal de contacto</h2>
        </div>
        <div class="popoup-content">
            <div class="block-looper">

                <div class="form-wrap w40 uppercase" *ngIf="hideOnAdding">
                    <mat-label aria-label="" class="label">Empresa</mat-label>
                    <mat-form-field appearance="fill" [ngClass]="{ readonly: empresaReadOnly }">
                        <input matInput placeholder="" type="text" formControlName="Empresa"
                            [readonly]="empresaReadOnly">
                    </mat-form-field>
                    <mat-error *ngIf="contactForm.get('Empresa').invalid && contactForm.get('Empresa').touched">
                        <span *ngIf="contactForm.get('Empresa').hasError('required')"> La empresa es obligatoria</span>
                    </mat-error>
                </div>
                <div class="form-wrap w40 uppercase">
                    <mat-label aria-label="" class="label">Nombre</mat-label>
                    <mat-form-field appearance="fill">
                        <input matInput placeholder="" type="text" formControlName="Nombre">
                    </mat-form-field>
                    <mat-error *ngIf="contactForm.get('Nombre').invalid && contactForm.get('Nombre').touched">
                        <span *ngIf="contactForm.get('Nombre').hasError('required')"> El nombre es obligatorio</span>
                    </mat-error>

                </div>
                <div class="form-wrap w20">
                    <mat-label aria-label="" class="label">Cargo</mat-label>
                    <mat-form-field appearance="fill">
                        <input matInput placeholder="" type="text" formControlName="Cargo">
                    </mat-form-field>
                </div>
                <div class="form-wrap w50">
                    <mat-label aria-label="" class="label">Email</mat-label>
                    <mat-form-field appearance="fill">
                        <input matInput placeholder="" type="email" formControlName="Email">
                    </mat-form-field>
                    <mat-error *ngIf="contactForm.get('Email').invalid && contactForm.get('Email').touched">
                        <span *ngIf="contactForm.get('Email').errors.pattern">El email es inválido</span>
                    </mat-error>
                </div>
                <div class="form-wrap w25">
                    <mat-label aria-label="" class="label">Telefono</mat-label>
                    <mat-form-field appearance="fill">
                        <input matInput placeholder="" type="text" formControlName="Telefono">
                    </mat-form-field>
                </div>
                <div class="form-wrap w25">
                    <mat-label aria-label="" class="label">Movil</mat-label>
                    <mat-form-field appearance="fill">
                        <input matInput placeholder="" type="text" formControlName="Movil">
                    </mat-form-field>
                </div>
                <div class="form-wrap">
                    <mat-label aria-label="" class="label">Comentarios</mat-label>
                    <mat-form-field appearance="fill">
                        <textarea matInput placeholder="" rows="4" formControlName="Comentarios" maxlength="200"></textarea>
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="popoup-footer">
            <button class="keep" (click)="onSubmit()"><span class="mat-button-wrapper">Guardar</span></button>
            <button class="cancel" (click)="cancel(false)"><span class="mat-button-wrapper">Cancelar</span></button>
        </div>
    </form>
</div>